export const GET_REQUESTS = 'GET_REQUESTS'
export const SET_REQUESTS = 'SET_REQUESTS'
export const MODIFY_REQUEST = 'MODIFY_REQUEST'
export const SET_SUPPORT_STATE = 'SET_SUPPORT_STATE'
